import { call, put, takeLatest } from 'redux-saga/effects';
import * as actions from '../actions';
import { GET_CN_LOCATION_LIST } from '../types';
import { getCNLocationListApi } from '../api';

export function* getCNLocationListSaga() {
  try {
    const { data } = yield call(getCNLocationListApi);
    if (data) {
      yield put(actions.setCNLocationList(data));
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
}

const addCarRegistrationInfoSaga = [takeLatest(GET_CN_LOCATION_LIST, getCNLocationListSaga)];

export default addCarRegistrationInfoSaga;
